import { motion } from 'framer-motion';

export const Logo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { mb: "text-xl", construction: "text-[8px]" },
    default: { mb: "text-3xl", construction: "text-[10px]" },
    large: { mb: "text-5xl md:text-6xl", construction: "text-xs md:text-sm" },
  };

  const currentSize = sizes[size] || sizes.default;

  return (
    <motion.div 
      className={`flex flex-col items-start ${className}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="relative">
        <span className={`font-heading font-light text-text-main ${currentSize.mb} tracking-tight`}>
          MB
        </span>
        <div className="absolute -right-1 top-0 w-8 h-[2px] bg-primary transform rotate-45 origin-left" />
      </div>
      <span className={`font-mono font-medium uppercase tracking-[0.2em] text-primary ${currentSize.construction} -mt-1`}>
        Construction
      </span>
    </motion.div>
  );
};

export default Logo;
